
import { combineReducers } from '@reduxjs/toolkit'

import smc from './data/slice'

const rootReducer = combineReducers({
  smc,
});

export default rootReducer
